import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ButtonIcon from '../../../../button';
import { Selected_Index } from '../../../../../constants/external-constants';
import { ListTabButton } from '../../../../common/list-tab/list-tab-button.component';
import PlanCatalogueFormView from '../plan-catalogue-form/plan-catalogue-form.component';
import PlanCatalogueComment from '../plan-catalogue-comment/plan-catalogue-comment.component';
import PlanCatalogueHistory from '../plan-catalogue-history/plan-catalogue-history.component';

class PlanCatalogueView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Comments",
                    "hidden": false,
                    "disable": true
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "History",
                    "hidden": false,
                    "disable": true
                },
            ],
        }
    }

    FilterIndex = (index) => {
        this.setState({ selectedIndex: index });
    }
    handleCloseForm = () => {
        const { closeFormAction, } = this.props;
        closeFormAction();
    }

    renderTabContent = (index) => {
        this.setState({ selectedTab: index });
    }

    activeListTab = (listTab) => {

        return listTab.map(item => {
            var disabled = item.disable;
             if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && this.props.planId > 0) {
                 disabled = false;
             }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    render() {
        const { listTab, selectedIndex } = this.state;
        const { closeFormAction, isReadOnly, isReadAndExtractOnly, isReadAndWrite, getPlanCatalogue, planId, isCreateNew } = this.props

        return (
            <div className="layout-container">
                <ButtonIcon onClick={this.handleCloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} /> : null}
                <div className={`${this?.props?.isMultiContainer ? "" : "details-container add-plan-catalogue"} date-picker-main-container`}>
                    {selectedIndex === Selected_Index.i_Zero &&
                        (
                        <PlanCatalogueFormView
                            handleCloseForm={this.handleCloseForm}
                            getPlanCatalogue={getPlanCatalogue}
                            //Access Type
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                            planDetailsId={planId ? planId : 0}
                            isCreateNew = {isCreateNew}
                        />
                        )
                     }
                    {selectedIndex === Selected_Index.i_One && 
                        (
                        <PlanCatalogueComment
                            planId={planId}
                            //Access Type
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                            isCreateNew = {isCreateNew}
                        />
                        )
                    }
                    {selectedIndex === Selected_Index.i_Two &&
                        (
                        <PlanCatalogueHistory
                                planId={planId}
                                //Access Type
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                                isCreateNew = {isCreateNew}
                        />
                        )
                    }

                </div>

            </div>
        );
    }
}

export default PlanCatalogueView;